/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { Panel } from 'react-bootstrap';
import { callAPI } from 'lorautils/api';
import DeviceMap from 'loracoms/DeviceMap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.object.isRequired,
};

class DeviceMapPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.intlMsg = new IntlMsg(props.intl, 'overview');
  }

  componentWillMount() {
    callAPI({
      endpoint: '/lora/nodes',
      query: { limit: 100 },
    }).then((data) => {
      this.setState({ devices: data.list });
    }).catch(() => {});
  }

  render() {
    const { devices = [] } = this.state;
    return (
      <Panel bsStyle="aisz-white" header={this.intlMsg.msg('devicemap')}>
        <div className={styles.map}>
          <DeviceMap devices={devices} />
        </div>
      </Panel>
    );
  }
}

DeviceMapPanel.propTypes = propTypes;

export default injectIntl(DeviceMapPanel);




// WEBPACK FOOTER //
// ./src/containers/Overview/DeviceMapPanel/index.jsx